import n from "./extends3.mjs";
import "react";
import { getPickersLayoutUtilityClass as q } from "./pickersLayoutClasses.mjs";
import { uncapitalizeObjectKeys as D } from "./slots-migration.mjs";
import { jsx as i } from "react/jsx-runtime";
import { PickersActionBar as E } from "./PickersActionBar.mjs";
import { useSlotProps as m } from "./useSlotProps.mjs";
import { PickersShortcuts as F } from "./PickersShortcuts.mjs";
import G from "./composeClasses.mjs";
function I(o) {
  return o.view !== null;
}
const J = (o) => {
  const {
    classes: e,
    isLandscape: r
  } = o;
  return G({
    root: ["root", r && "landscape"],
    contentWrapper: ["contentWrapper"],
    toolbar: ["toolbar"],
    actionBar: ["actionBar"],
    tabs: ["tabs"],
    landscape: ["landscape"],
    shortcuts: ["shortcuts"]
  }, q, e);
}, no = (o) => {
  var e, r;
  const {
    wrapperVariant: a,
    onAccept: B,
    onClear: C,
    onCancel: g,
    onSetToday: x,
    view: l,
    views: T,
    onViewChange: h,
    value: k,
    onChange: V,
    onSelectShortcut: P,
    isValid: b,
    isLandscape: u,
    disabled: L,
    readOnly: N,
    children: A,
    components: _,
    componentsProps: j,
    slots: v,
    slotProps: S
    // TODO: Remove this "as" hack. It get introduced to mark `value` prop in PickersLayoutProps as not required.
    // The true type should be
    // - For pickers value: TDate | null
    // - For range pickers value: [TDate | null, TDate | null]
  } = o, t = v ?? D(_), s = S ?? j, c = J(o), w = (e = t?.actionBar) != null ? e : E, O = m({
    elementType: w,
    externalSlotProps: s?.actionBar,
    additionalProps: {
      onAccept: B,
      onClear: C,
      onCancel: g,
      onSetToday: x,
      actions: a === "desktop" ? [] : ["cancel", "accept"],
      className: c.actionBar
    },
    ownerState: n({}, o, {
      wrapperVariant: a
    })
  }), U = /* @__PURE__ */ i(w, n({}, O)), p = t?.toolbar, f = m({
    elementType: p,
    externalSlotProps: s?.toolbar,
    additionalProps: {
      isLandscape: u,
      onChange: V,
      value: k,
      view: l,
      onViewChange: h,
      views: T,
      disabled: L,
      readOnly: N,
      className: c.toolbar
    },
    ownerState: n({}, o, {
      wrapperVariant: a
    })
  }), W = I(f) && p ? /* @__PURE__ */ i(p, n({}, f)) : null, $ = A, y = t?.tabs, z = l && y ? /* @__PURE__ */ i(y, n({
    view: l,
    onViewChange: h
  }, s?.tabs)) : null, d = (r = t?.shortcuts) != null ? r : F, H = m({
    elementType: d,
    externalSlotProps: s?.shortcuts,
    additionalProps: {
      isValid: b,
      isLandscape: u,
      onChange: P,
      className: c.shortcuts
    },
    ownerState: {
      isValid: b,
      isLandscape: u,
      onChange: P,
      className: c.shortcuts,
      wrapperVariant: a
    }
  }), K = l && d ? /* @__PURE__ */ i(d, n({}, H)) : null;
  return {
    toolbar: W,
    content: $,
    tabs: z,
    actionBar: U,
    shortcuts: K
  };
};
export {
  no as default
};
//# sourceMappingURL=usePickerLayout.mjs.map
